module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAQdJREFUOBHtUzFKQ0EQfbO7QmJjwC5G+b1FFrRQG7ex9wam9BYxN/AIegN7C9fKCAo/N7DwAFpFMPnjm+0CQQLpxIH9+2be2zewfxZYM8TOHx6lpIK+g9TfU53Udf5Y5htj6my0pd9AoygmL+OcQxE6JDoNFYqwScOTVKviZj7FrfG+jQsRDAijaUpXwYh5loPjdE3SOg65FkPxWAqC00WiZCM26Ti6xSXkSiU761ZS/iL6NwD+wB0E5TBwIB74q6/mineZNV8S3Bnzc9ZLcOI+Ce501txrcC0v6Blh78fv7FUtYtMKx3JLvGwT59enPOj2qreCx/myu1vBedk3jWlt8fPMfb34AUBARCPLjVIHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/Mask Group 106.png
// module id = 1260
// module chunks = 0